import * as types from '../types';

export const startFetchingUserNotifications = (filters = {}) => ({
  type: types.USER_NOTIFICATIONS_FETCH_STARTED,
  payload: filters
});

export const completeFetchingUserNotifications = (entities, order) => ({
  type: types.USER_NOTIFICATIONS_FETCH_COMPLETED,
  payload: {
    entities,
    order
  }
});

export const completeFetchingUserEvents = (entities, order) => ({
  type: types.USER_PUSH_NOTIFICATIONS_FETCH_COMPLETED,
  payload: {
    entities,
    order
  }
});

export const failFetchingUserNotifications = (
  error = { errorMessage: 'Error', errorNumber: 404 }
) => ({
  type: types.USER_NOTIFICATIONS_FETCH_FAILED,
  payload: {
    error
  }
});

export const startPartialFetchingUserNotifications = (
  entityTypeId,
  operatorId = null,
  organizationId = null
) => ({
  type: types.USER_NOTIFICATIONS_PARTIAL_FETCH_STARTED,
  payload: {
    entityTypeId,
    operatorId,
    organizationId
  }
});

export const completePartialFetchingUserNotifications = (
  entities,
  order,
  operatorId,
  organizationId
) => ({
  type: types.USER_NOTIFICATIONS_PARTIAL_FETCH_COMPLETED,
  payload: {
    entities,
    order,
    operatorId,
    organizationId
  }
});

export const failPartialFetchingUserNotifications = (
  error = { errorMessage: 'Error', errorNumber: 404 }
) => ({
  type: types.USER_NOTIFICATIONS_PARTIAL_FETCH_FAILED,
  payload: {
    error
  }
});

export const startReadingUserNotification = (notificationIds) => ({
  type: types.USER_NOTIFICATION_READ_STARTED,
  payload: notificationIds
});

export const completeReadingUserNotification = (notifications, notificationIds) => ({
  type: types.USER_NOTIFICATION_READ_COMPLETED,
  payload: {
    notifications,
    notificationIds
  }
});

export const failReadingUserNotification = (notificationIds) => ({
  type: types.USER_NOTIFICATION_READ_FAILED,
  payload: notificationIds
});

export const selectUserNotification = (notificationId) => ({
  type: types.USER_NOTIFICATION_SELECTED,
  payload: notificationId
});

export const selectAllUserNotification = (notificationIds: any[] = []) => ({
  type: types.USER_NOTIFICATION_ALL_SELECTED,
  payload: notificationIds
});

export const deselectUsermNotification = (notificationId) => ({
  type: types.USER_NOTIFICATION_DESELECTED,
  payload: notificationId
});

export const deselectAllUserNotification = (notificationIds: any[] = []) => ({
  type: types.USER_NOTIFICATION_ALL_DESELECTED,
  payload: notificationIds
});

export const userNotificationShown = (notificationId) => ({
  type: types.USER_NOTIFICATION_SHOWN,
  payload: notificationId
});
